import { ChangePasswordInterface } from 'modules/profile/change-password/types/change-password-interface'
import httpClient from 'shared/utils/http-client'

const CHANGE_PASSWORD_API = '/api/dashboard/profile/change-password'

export const changePassword = (data: ChangePasswordInterface) =>
  httpClient.post(CHANGE_PASSWORD_API, data)
